export default __webpack_public_path__ + "219a111fcdaf480cf495ee0123614146.svg";